export default __webpack_public_path__ + "static/media/photo--lg--group.82547753.jpg";